var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warpImgEl"},[_c('el-upload',{attrs:{"action":_vm.httpUrl,"headers":_vm.headers,"before-upload":_vm.UploadLimitBtn,"on-success":_vm.uploadImg}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }